import { Listbox } from '@headlessui/react';
import { CheckIcon } from '@heroicons/react/solid';
import { FC } from 'react';
import { twMerge } from 'tailwind-merge';
import { SelectOption } from './types';

type SelectItemProps = {
  item: SelectOption;
};

export const SelectItem: FC<SelectItemProps> = ({ item }) => {
  return (
    <Listbox.Option
      value={item}
      disabled={item.disabled}
      className={({ selected, active, disabled }) =>
        twMerge(
          'relative select-none p-2.5',
          'motion-safe:transition-colors motion-safe:duration-200 motion-reduce:transition-none',
          active ? 'bg-primary-hover' : '',
          selected ? 'bg-primary-hover' : '',
          disabled && 'text-quaternary-500 cursor-not-allowed'
        )
      }
    >
      {({ selected, disabled }) => (
        <>
          <div className={'flex items-center text-base'}>
            {item.image && <span className='mr-3 inline-block align-middle'>{item.image}</span>}
            <span className={'block truncate'}>{item.label}</span>
          </div>
          {selected ? (
            <span className='absolute inset-y-0 right-0 flex items-center pe-2.5 '>
              <CheckIcon className={twMerge('size-5 text-brand-600', disabled && 'text-foreground-disabled')} />
            </span>
          ) : null}
        </>
      )}
    </Listbox.Option>
  );
};
